import React, {useEffect, useState} from 'react';
import styles from "page/css/Exhibition.module.css";

import Button from "../inputs/Button";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

import ExhibitionService from "service/apiConfig/ExhibitionService";

import { useDispatch, useSelector } from "react-redux";
import { exhibitionActions } from "reducers/exhibition";

const ExhibitionFormHeader = ({ create, edit }) => {
    const dispatch = useDispatch();
    const type = useSelector(state => state.exhibitionData.type);
    const exhibitionRoom = useSelector(state => state.exhibitionData.exhibitionRoom);
    const [selectList, setSelectList] = useState([]);
    useEffect(() => {
        if (type === 'kor') {
            ExhibitionService.getCommentatorByType(1)
                .then(response => {
                    dispatch(exhibitionActions.setCommentatorList(response.data.data));
                })
                .catch(err => console.log(err));
        } else if (type === 'eng') {
            ExhibitionService.getSelect()
                .then(response => {
                    setSelectList(response.data.data);
                })
                .catch(err => console.log(err));
            ExhibitionService.getCommentatorByType(2)
                .then(response => {
                    dispatch(exhibitionActions.setCommentatorList(response.data.data));
                })
                .catch(err => console.log(err));
        }
    }, [type, dispatch]);

    const handleSelectParentId = (e) => {
        dispatch(exhibitionActions.setExhibitionRoom({...exhibitionRoom, parentId: e.target.value}))
    }
    const handleType = (type) => {
        dispatch(exhibitionActions.setType(type));
        dispatch(exhibitionActions.setExhibitionRoom({
            name: "",
            introduction: "",
            roomNo: "",
            invalid: true,
            language: 1,
            parentId: null,
            imageUrl: "",
            commentator: { id : null },
            commentatorForKid: { id : null },
            commentatorForBlind: { id : null },
        }))
        dispatch(exhibitionActions.setSubTopicList([]));
        dispatch(exhibitionActions.setFile(null));
        dispatch(exhibitionActions.setPreviewImage(null));
    }
    return (
        <article style={{ display: edit && 'flex' }}>
            <Button className={`${styles.typeBtn} ${type === "kor" ? styles.active : ''} ${edit && styles.edit}`} disabled={edit} type={"button"} onClick={() => handleType("kor")}>일반 / 어린이 / 시각장애인</Button>
            <Button className={`${styles.typeBtn} ${type === "eng" ? styles.active : ''} ${edit && styles.edit}`} disabled={edit} type={"button"} onClick={() => handleType("eng")}>영문</Button>
            {type === "eng" &&
                <FormControl size="small" sx={{ minWidth: "150px", height: "35px", boxSizing: "border-box", marginLeft: "2rem" }}>
                    <InputLabel id="demo-simple-select-label">연관 데이터</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={exhibitionRoom.parentId || ''}
                        label="연관 데이터"
                        className={"ellipsis1"}
                        onChange={handleSelectParentId}
                    >
                        {selectList.map((select, index) => (
                            <MenuItem key={select.id} value={select.id} sx={{ fontSize: "15px" }}><span style={{ maxWidth: "150px" }} className={"selectSpan ellipsis1"}>{select.roomId}</span><span style={{ maxWidth: "300px" }} className={"ellipsis1"}>{select.name}</span></MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </article>
    );
};

export default ExhibitionFormHeader;